import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentFlexibleIdentifier on FlexibleIdentifier {
    id
    alias
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentFlexibleIdentifierFragment,
  ents.core.common.FlexibleIdentifier<string>
>({
  alias: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
})
